import React, { createContext, useCallback, useContext, useState } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter } from './ProductsUIHelpers';

const ProductsUIContext = createContext();

export function useProductsUIContext () {
    return useContext(ProductsUIContext);
}

export const ProductsUIConsumer = ProductsUIContext.Products;

export function ProductsUIProvider ({ productsUIEvents, children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [cards, setCards] = useState([]);
    const [insurances, setInsurances] = useState([]);
    const [loans, setLoans] = useState([]);
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const value = {
        isLoading,
        setIsLoading,
        queryParams,
        setQueryParams,
        setQueryParamsBase,
        cards,
        setCards,
        insurances,
        setInsurances,
        loans,
        setLoans
    };

    return <ProductsUIContext.Provider value={value}>{children}</ProductsUIContext.Provider>;
}
